function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import keys from 'lodash/keys';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import map from 'lodash/map';
import includes from 'lodash/includes';
import CheckIcon from 'svg/check-thin.svg';
import ErrorIcon from 'svg/error-mark.svg';
import XIcon from 'svg/x-thin.svg';
import formMessages from 'components/Form/messages';
import { PASSWORD_RULES } from '../../constants';
import messages from '../../messages';
import styles from './Password.pcss';
const renderValidationRules = (rule, isValid, isEmptyValue)=>{
    let Icon = /*#__PURE__*/ _jsx("div", {
        className: styles.criteria__listItemBullet
    });
    if (!isEmptyValue) {
        if (isValid) {
            Icon = /*#__PURE__*/ _jsx(CheckIcon, {
                className: cn(styles.criteria__listItem__icon, styles.criteria__listItem__icon)
            });
        } else {
            Icon = /*#__PURE__*/ _jsx(XIcon, {
                className: cn(styles.criteria__listItem__icon, styles.criteria__listItem__icon)
            });
        }
    }
    return /*#__PURE__*/ _jsx("li", {
        className: cn(styles.criteria__listItem, {
            [styles['criteria__listItem--isValid']]: !isEmptyValue && isValid
        }, {
            [styles['criteria__listItem--isNotValid']]: !isEmptyValue && !isValid
        }),
        children: /*#__PURE__*/ _jsxs("div", {
            className: styles.criteria__listItem__innerContainer,
            children: [
                Icon,
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, formMessages.validationErrors[rule]))
            ]
        })
    }, rule);
};
export const renderPasswordCriteria = (errors, isEmptyValue)=>{
    const rulesWithErrors = keys(errors);
    const baseErrors = rulesWithErrors && rulesWithErrors.filter((rule)=>!PASSWORD_RULES.includes(rule));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            baseErrors && map(baseErrors, (rule)=>/*#__PURE__*/ _jsxs("div", {
                    className: "form-text form-error",
                    children: [
                        /*#__PURE__*/ _jsx(ErrorIcon, {}),
                        /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, formMessages.validationErrors[rule] || messages.validatorRules[rule]), {
                            values: errors[rule]
                        }))
                    ]
                }, rule)),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.criteria,
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: styles.criteria__header,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, formMessages.infos.passwordRequirements))
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: cn(styles.criteria__list, {
                            [styles['criteria__list--isValidated']]: !isEmptyValue
                        }),
                        children: map(PASSWORD_RULES, (rule)=>{
                            const isValid = !includes(rulesWithErrors, rule);
                            return renderValidationRules(rule, isValid, isEmptyValue);
                        })
                    })
                ]
            })
        ]
    });
};
